import forEach from 'lodash/forEach';
import values from 'lodash/values';

import { TInitialState, TRouter } from '~/src/features/tariffBuilder/reducer';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

import { IDecoderEntity } from '../types/entity';

type TSelectedItem = {
    id: number,
    type: EEntity | 'vas',
    count?: number,
    duration?: number,
    monthly?: number,
    planType?: number,
}

export type TSelectedEntities = {
    items: TSelectedItem[],
    summary: {
        once: number,
        monthly: number,
        connection: number,
        tariff: number,
    },
};

type TItemMap = {
    label: string,
    entities: Exclude<EEntity, EEntity.speed | EEntity.entertainments | EEntity.services>[],
}

const itemsMap: TItemMap[] = [
    { label: 'Телевидение', entities: [EEntity.tv] },
    { label: 'Подписки', entities: [EEntity.onlineCinemas, EEntity.additional, EEntity.antivirus, EEntity.security] },
    { label: 'Роутеры', entities: [EEntity.routers] },
    { label: 'Приставки', entities: [EEntity.decoders] },
];

const INSTALLMENT_TYPE = 5; // тип покупка в рассрочку
const PURCHASE_TYPE = 1; // тип выкуп

const getEntityByGlobalId = (type: EEntity.decoders | EEntity.routers, globalId: number, state: TInitialState): TRouter | IDecoderEntity  => {
    return Object.values(state[type]).find(item => item.globalId === globalId);
};

/**
 *
 * @deprecated
 * Добавили селект чтобы сохранить обратную совместимость.
 * Для создании заявки на смену тарифа нужны параметры planType и mountly
 *
 */
export const getSelectedEntitiesCurrentTariff = (state: TInitialState): TSelectedEntities => {
    const equipment = getSelectedEntities(state);

    const equipmentItems = equipment.items.map(item => {
        if (item.type === EEntity.routers || item.type === EEntity.decoders) {
            const entity = getEntityByGlobalId(item.type, item.id, state);
            return {
                ...item,
                planType: entity.costs[entity.selectedCost].period === 1 ? PURCHASE_TYPE : INSTALLMENT_TYPE,
                monthly:  entity.costs[entity.selectedCost].period === 1 ? 0 : entity.costs[entity.selectedCost].cost,
            };
        }
        return item;
    });

    return { ...equipment, items: equipmentItems };
};
// This selector should be used for agreement creation function
const getSelectedEntities = (state: TInitialState): TSelectedEntities => {
    let isTvSelected = false;

    const result = itemsMap.reduce<TSelectedEntities>((acc, item) => {
        forEach(
            item.entities,
            entity => {
                switch (entity) {
                    case EEntity.routers: {
                        Object.values(state[EEntity.routers])
                            .filter(router => router.quantity > 0)
                            .forEach(router => {
                                acc.items.push({
                                    id: router.globalId,
                                    type: EEntity.routers,
                                    count: router.quantity,
                                    duration: router.costs[router.selectedCost].period === 1 ? 0 : router.costs[router.selectedCost].period,
                                });
                                const payType = router.costs[router.selectedCost].period === 1 ? 'once' : 'monthly';
                                acc.summary[payType] += router.costs[router.selectedCost].cost * router.quantity;
                            });

                        break;
                    }
                    case EEntity.decoders: {
                        Object.values(state[EEntity.decoders])
                            .filter(decoder => decoder.quantity > 0)
                            .forEach(decoder => {
                                acc.items.push({
                                    id: decoder.globalId,
                                    type: EEntity.decoders,
                                    count: decoder.quantity,
                                    duration: decoder.costs[decoder.selectedCost].period === 1 ? 0 : decoder.costs[decoder.selectedCost].period,
                                });
                                const payType = decoder.costs[decoder.selectedCost].period === 1 ? 'once' : 'monthly';
                                acc.summary[payType] += decoder.costs[decoder.selectedCost].cost * decoder.quantity;
                            });

                        break;
                    }
                    case EEntity.tv: {
                        forEach(
                            state[EEntity.tv],
                            tvGroup => {
                                values(tvGroup.items)
                                    .filter(tvItem => tvItem.quantity > 0)
                                    .forEach(tvItem => {
                                        acc.items.push({
                                            id: tvItem.id,
                                            type: 'vas',
                                        });
                                        if (!isTvSelected) {
                                            isTvSelected = true;
                                        }
                                        acc.summary.tariff += tvItem.cost.final;
                                    });
                            },
                        );

                        break;
                    }
                    default: {
                        values(state[entity])
                            .filter(e => e.quantity > 0)
                            .forEach(i => {
                                acc.items.push({
                                    id: i.id,
                                    type: 'vas',
                                    count: i.quantity,
                                });
                                acc.summary.tariff += i.cost.final * i.quantity;
                            });
                    }
                }
            },
        );

        return acc;
    }, { items: [], summary: { once: 0, monthly: 0, connection: 0, tariff: 0 } });

    const selectedSpeed = state[EEntity.speed][state.selectedSpeed];
    result.summary.connection = isTvSelected ? 1001 : 1000;
    result.summary.tariff += selectedSpeed.price;
    return result;
};

export default getSelectedEntities;
